export const gtmAddToCartEvent = (productData: any, orderId: number, encDesignId: string, locale: string) => ({
  event: 'addToCart',
  ecommerce: {
    orderId,
    currencyCode: 'NOK',
    add: {
      products: [productData],
    },
    designEnc: [(locale + encDesignId).replace(/[^A-Za-z0-9 ]/g, '')],
  },
});

export default gtmAddToCartEvent;
